import { Task } from './task.model';

export class MachineSetting {
    id?: string;
    code: string;
    name: string;
    description?: string;
    group: string;
    tasks?: Task[];

    constructor(msetting) {
        if (msetting.id) { this.id = msetting.id; }
        this.code = msetting.code;
        this.name = msetting.name;
        if (msetting.description) { this.description = msetting.description; }
        this.group = msetting.group;
        if (msetting.tasks) { this.tasks = msetting.tasks.map(t => new Task(t)); }
    }

    get codeName(): string {
      return this.code + ' - ' + this.name;
    }
}
